




















import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import Node from "../../../node/node.vue"

@Component({
  components: {
      "NodeView" : Node
    }
})
export default class GroupNode1 extends Vue 
{
    @Prop() node! : any;
    @Prop() selectedNode! : any;
    @Prop() hierarchy! : number;

    mounted(){
        // 開いたときに親要素にIDを送る
        this.$emit("setChildren", this.node.id);        
    }

    get childrenHierarchy(){
        return this.hierarchy + 1;
    }

    select(id , hierarchy){
        this.$emit("select" , id , hierarchy)
    }

    open(id , hierarchy){
        this.$emit("open" , id , hierarchy)
    }

    private childrenIdList = new Array(); 
    setChildren(childId){
        if(this.childrenIdList.indexOf(childId) == -1){
            this.childrenIdList.push(childId);
            this.$emit("setChildren", childId);
        }
    }

    private get userConfigBackgroundColor(){
        var style : any = {};
        if(this.node.id == this.selectedNode.id && this.node.hierarchy == this.selectedNode.hierarchy
        || this.childrenIdList.indexOf(this.selectedNode.id) != -1){
            var rgb = this.$store.getters.userConfigColors.buttonColorRgb;
            style = {
                position: "relative",
                display: "table",
                width: "calc(100% + " + (16 * this.hierarchy) + "px)",
                height: "25px",
                left : -16 * this.hierarchy + "px",
                backgroundColor : "rgba( " + rgb.r + " , " + rgb.g + " , " + rgb.b + " , 0.5 )",
                pointerEvents: "none"
            }
            if(this.childrenIdList.indexOf(this.selectedNode.id) != -1){
                style.backgroundColor = this.$store.getters.userConfigColors.buttonColorRgba;
            }
        }
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    
}
